import BotComponent from "./BotComponent";
import LinksComponent from "./LinksComponent";
import { useEffect, useState } from "react";
import {
  Newspaper,
  Compass,
  Megaphone,
  Shirt,
  Building2,
  CalendarCheck,
} from "lucide-react";
import "./UsefulResources.css";

const ICON_MAP = {
  Shirt,
  Megaphone,
  Compass,
};

const TELEBOTS_DATA = `${process.env.PUBLIC_URL}/telebots.json`;

const websites = [
  {
    id: 1,
    icon: Newspaper,
    title: "CAPT Life",
    description:
      "Student-run portal with news, events, resources, and community info for CAPT students.",
    websiteLink: "https://captlife.com/",
  },
  {
    id: 2,
    icon: Building2,
    title: "NUS CAPT",
    description:
      "Official NUS CAPT website with program details, announcements, and contact info.",
    websiteLink: "https://capt.nus.edu.sg/",
  },
  {
    id: 3,
    icon: CalendarCheck,
    title: "Treeckle",
    description:
      "CAPT's own system for booking, availability checking, and reserving spaces.",
    websiteLink: "https://treeckle.com/",
  },
];

export default function UsefulResources() {
  const [telebots, setTelebots] = useState([]);

  useEffect(() => {
    const loadTelebots = async () => {
      try {
        const response = await fetch(TELEBOTS_DATA);
        if (!response.ok) {
          return;
        }

        const data = await response.json();
        if (!Array.isArray(data)) {
          return;
        }

        setTelebots(
          data.map((bot) => ({
            ...bot,
            icon: ICON_MAP[bot.icon] || Compass,
          })),
        );
      } catch (error) {
        // Keep rendering stable if telebots endpoint is temporarily unavailable.
      }
    };

    loadTelebots();
  }, []);

  return (
    <section className="telegram-bots-page">
      <div className="telegram-bots-page__header">
        <h1 className="telegram-bots-page__title">Useful Resources</h1>
        <p className="telegram-bots-page__subtitle">
          Connect to helpful bots and explore quick links for important CAPT and
          campus resources.
        </p>
      </div>

      <section className="resource-section">
        <h2 className="resource-section-title">Telegram Bots</h2>
        <div className="telegram-bots-page__grid">
          {telebots.map((bot) => (
            <BotComponent
              key={bot.id}
              icon={bot.icon}
              title={bot.title}
              description={bot.description}
              telegramLink={bot.telegramLink}
              instructions={bot.instructions}
            />
          ))}
        </div>
      </section>

      <section className="resource-section resource-section--links">
        <h2 className="resource-section-title">Useful Links</h2>
        <div className="telegram-bots-page__grid">
          {websites.map((linkItem) => (
            <LinksComponent
              key={linkItem.id}
              icon={linkItem.icon}
              title={linkItem.title}
              description={linkItem.description}
              websiteLink={linkItem.websiteLink}
            />
          ))}
        </div>
      </section>
    </section>
  );
}
